// extracted by mini-css-extract-plugin
export var oButton = "button-module--o-button--2xljM";
export var conversion = "button-module--conversion--TYbwz";
export var weak = "button-module--weak--11b18";